(()=>{
  function init(){
    const root=document.querySelector('[data-hfd]');
    if(!root)return;

    function apply(){
      root.querySelectorAll('[data-line-options]').forEach(lineOptions=>{
        const splitGroup=lineOptions.closest('.hfd__group');
        if(!splitGroup)return;
        const pane=lineOptions.closest('[data-hfd-side]');
        const count=Number(pane?.querySelector('[data-count].is-active')?.dataset.count||1);
        const disabled=count===1;
        splitGroup.classList.toggle('hfd__split-disabled',disabled);
        lineOptions.querySelectorAll('input,select,button').forEach(el=>el.disabled=disabled);
      });
    }

    root.addEventListener('click',e=>{
      if(e.target.closest?.('[data-count]'))requestAnimationFrame(apply);
    });
    document.addEventListener('flag:design-change',()=>requestAnimationFrame(apply));
    apply();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
